import { useLoaderData } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoginPageLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: theme.palette.background.paper,
}));

/**
 * Renders only if the loader returned (e.g. loginWithRedirect failed).
 * Normally the loader redirects to Auth0 and this page never mounts.
 */
export function LoginPage() {
  useLoaderData();

  return (
    <LoginPageLayout>
      <CircularProgress />
    </LoginPageLayout>
  );
}
